import { render, staticRenderFns } from "./BaseIconAlert.vue?vue&type=template&id=57149d02&"
import script from "./BaseIconAlert.vue?vue&type=script&lang=js&"
export * from "./BaseIconAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports